import React from "react";

function Footer() {
  return (
    <div className="footer">
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="copyright-box">
              <p className="copyright">
                © Copyright <strong>DevFolio</strong>. All Rights Reserved
              </p>
              <div className="credits">
                Designed by{" "}
                <a href="https://bootstrapmade.com/">BootstrapMade</a>,
                Developed by John Yves Marin
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
